import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmationPopupComponent } from '../components/confirmation-popup/confirmation-popup.component';
import { ICanDeactivate } from './can-deactivate-interface';


@Injectable({
  providedIn: 'root'
})

export class CanDeactivateGuard implements CanDeactivate<ICanDeactivate> {


  constructor(public dialog: MatDialog) {

  }
  canDeactivate(
    component: ICanDeactivate): boolean | Observable<boolean> {
    if(component.DetectChanges())
    {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        id: "alert-popup"
      });

      return dialogRef.afterClosed();
    }
    else
    {
      return true;
    }
  }

}
